import React from 'react';
const OilInformationSection = () => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = '/lovable-uploads/90959052-01e0-4de5-a75c-812d72605f31.png';
    console.log('Information section image failed to load, using fallback');
  };
  return <section className="section-padding bg-autocare-gray-light">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-semibold text-autocare-blue bg-autocare-blue/10 rounded-full mb-4">
              Oil Guide
            </span>
            <h2 className="text-3xl font-bold text-autocare-blue mb-4">Understanding Motor Oil Types</h2>
            <p className="text-gray-600 mb-6">
              Choosing the right oil is crucial for your engine's performance and longevity. Here's what you need to know about different oil types.
            </p>
            
            <div className="space-y-6">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Full Synthetic Oil</h3>
                <p className="text-gray-600 text-sm">
                  The highest quality motor oil offering superior engine protection, better performance in extreme temperatures, and longer intervals between changes.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Synthetic Blend Oil</h3>
                <p className="text-gray-600 text-sm">
                  A mix of synthetic and conventional oils that provides good protection at a lower cost than full synthetic, ideal for drivers with moderate requirements.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">Conventional Oil</h3>
                <p className="text-gray-600 text-sm">
                  The standard oil type that meets basic requirements for most vehicles, typically requiring more frequent changes but at a lower cost.
                </p>
              </div>
              
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h3 className="font-semibold text-lg mb-2">High-Mileage Oil</h3>
                <p className="text-gray-600 text-sm">Specifically formulated for vehicles with over 75,000 KM, containing additives that help reduce oil consumption and prevent leaks.</p>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img alt="Different types of motor oil" className="rounded-xl shadow-lg" onError={handleImageError} src="/lovable-uploads/68022d58-c3ac-40cf-ae5e-49931a06210b.jpg" />
            
            <div className="absolute -bottom-6 -right-6 bg-autocare-yellow p-4 rounded-lg shadow-lg">
              <div className="text-autocare-blue text-center">
                <div className="text-xl font-bold">5,000+</div>
                <div className="text-sm">Oil Changes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default OilInformationSection;